import { useApiSend } from "@/hooks/useApi";
import { unwatchVideo } from "../api";
import { useQueryClient } from "@tanstack/react-query";

export function useUnwatchVideo({ unit }) {
	const queryClient = useQueryClient();

	const { mutateAsync, isPending, isError, error } = useApiSend({
		mutationKeys: [
			"courses",
			unit.module.course.slug,
			"modules",
			unit.module.slug,
			"units",
			unit.slug,
			"unwatch",
		],
		fn: (data) => unwatchVideo({ unit }),
	});

	return {
		unwatch: async () => {
			await mutateAsync();
			queryClient.invalidateQueries({
				queryKey: ["courses", unit.module.course.slug, "units"],
			});

			queryClient.invalidateQueries({
				queryKey: [
					"courses",
					unit.module.course.slug,
					"modules",
					unit.module.slug,
					"units",
					unit.slug,
				],
			});
		},
		isPending,
		error,
		isError,
	};
}
